import { render } from "./supporttable.vue?vue&type=template&id=45c9eaf9"
import script from "./supporttable.vue?vue&type=script&lang=js"
export * from "./supporttable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__